import React, { Component } from 'react'
import { HBBModal } from '../../../Modal/Components'
import { PermanentEmployeeModalLayout } from '../EmployeeModalLayout'

class PermanentEmployee extends Component {
    constructor() {
        super()
        this.state = {
            isPermanentEmployeeModalOpened: false,
        }
    }
    opePermanentEmployeeModal = () => {
        this.setState({ isPermanentEmployeeModalOpened: true })
    }

    controlOpenCloseOfModal = (status) => {
       this.setState({ isPermanentEmployeeModalOpened: status })
    }

    refreshOrderList = () => {
        this.props.refreshOrderList()
    }

    render() {
        let modalComponent = null

        if (this.state.isPermanentEmployeeModalOpened) {
            modalComponent =
                <HBBModal>
                    <PermanentEmployeeModalLayout data={this.props.data}
                        closeModal={this.controlOpenCloseOfModal}
                        />
                </HBBModal>
        }
        return (
            <div>
                {modalComponent}

                 <button
                    title="Make Permanent"
                    className="action-button"
                    style={{ marginBottom: "1px",background:"green" }}
                    onClick={(e) => {
                        e.preventDefault()
                         this.opePermanentEmployeeModal()
                    }}>
                    Make Parmanent
                </button>
            </div>
        )
    }
}

export default PermanentEmployee


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/ActionButtons/PermanentEmployee.js